<template>
    <ComponentForm
        @save="save"
        @goBack="goBack"
        @reset="reset"
        :label="trads.editHead"
        :loading="loading || saving"
        :data="component"
    ></ComponentForm>
</template>
<script>
import ComponentForm from "./component-form";
import componentService, { COMPONENT_NAME } from "@/services/component";
import TryLoadMixin, { TrySaveMixin } from "@/mixins/TryLoadMixin";

export default {
    name: "EditComponent",
    mixins: [TryLoadMixin, TrySaveMixin],
    components: { ComponentForm },
    data: () => ({
        component: undefined,
        initialComponent: undefined
    }),
    created() {
        this.fetchComponent();
    },
    computed: {
        componentId() {
            return this.$route.params.id && Number.parseInt(this.$route.params.id, 10);
        },
        trads() {
            return this.$trad.admin.componentForm;
        }
    },
    methods: {
        async fetchComponent() {
            const res = await this.tryLoad(() => componentService.get(this.componentId));
            this.component = res;
            this.initialComponent = res;
        },
        reset() {
            this.component = { ...this.initialComponent };
        },
        goBack() {
            this.$router.push({ path: `/${COMPONENT_NAME[this.initialComponent.type.name]}/${this.initialComponent.id}` });
        },
        async save(value) {
            const { id, type } = await this.trySave(() => componentService.update(this.componentId, value));
            this.dialogSuccess(this.trads.successEditedMessage);
            this.$router.push({ path: `/${COMPONENT_NAME[type.name]}/${id}` });
        }
    }
};
</script>
<style lang="scss">
#main #component-form {
    width: 767px;
    margin: 40px auto;

    @media (max-width: 767px) {
        width: calc(100% - 60px);
    }

    > header {
        margin-bottom: 30px;
        h2 {
            margin: 10px 0;
        }
    }

    > section {
        margin-top: 30px;
    }

    ul {
        margin: 0;
        padding: 0;
        > li {
            list-style-type: none;
        }
    }

    section {
        display: grid;
        grid-template-columns: auto 1fr;
        margin-bottom: 30px;
        grid-column-gap: 20px;
        grid-row-gap: 15px;

        @media (min-width: 767px) {
            align-items: start;
            justify-items: start;
        }

        @media (max-width: 767px) {
            grid-row-gap: 4px;
            grid-template-columns: 1fr;

            > :not(label) {
                margin: 0 15px;
            }
            label {
                &:not(:first-of-type) {
                    margin-top: 15px;
                }
            }
        }
    }

    label {
        text-transform: uppercase;
        font-weight: bold;

        &[required]::after {
            content: " *";
            color: red;
        }
    }

    > .error {
        color: red;
        font-weight: bold;
    }
}
</style>



// WEBPACK FOOTER //
// edit-component.vue?d65a53a2